import '@spectrum-web-components/theme/sp-theme.js';
import '@spectrum-web-components/theme/theme-lightest.js';
import '@spectrum-web-components/theme/scale-medium.js';
import '@spectrum-web-components/theme/spectrum-two/scale-medium.js';
import '@spectrum-web-components/theme/spectrum-two/theme-light.js';

import '@spectrum-web-components/icons-workflow/icons/sp-icon-alert.js';
import '@spectrum-web-components/icons-workflow/icons/sp-icon-cclibrary.js';
import '@spectrum-web-components/icons-workflow/icons/sp-icon-code.js';
import '@spectrum-web-components/icons-workflow/icons/sp-icon-heart.js';
import '@spectrum-web-components/icons-workflow/icons/sp-icon-more.js';

import '@adobe-fonts/site/components/display-in-font/DisplayInFont.js';
import '@adobe-fonts/site/components/feedback-button/FeedbackButton.js';
import '@adobe-fonts/site/components/notification-toast/NotificationToast.js';
import '@adobe-fonts/site/components/search-bar/SearchBar.js';
import '@adobe-fonts/site/components/top-navbar/TopNavbar.js';

import('../util/visual_search.js').then(function(visualSearch) {
  visualSearch.init();
});

import '../components/LocaleSwitcher.js';
import '../components/SearchDialogTrigger.js';
import '../components/UniversalNav.js';
import '../components/NewRelicLinkClickTracking.js';
import '../components/TopAppBar.js';
import '../components/SUSILight.js';
import '../components/BottomNotification.ts';
import '../components/TopNotifications.ts';

void import('@adobe-fonts/site/components/libraries/save-library-icon/SaveLibraryIcon.js');
